import * as React from 'react';
import { Helmet } from 'react-helmet';

import loadable from '@common/react/loadable/loadableSettings';
import { useSizableProviderContext } from '@common/react/components/Core/SizableWithServerPage/SizableWithServerPage';

import { UserGroupType } from '@commonTuna/react/objects/UserGroup';

import SecureRouteWrapper from '@app/components/Routes/SecureRouteWrapper';
import { useUserGroupContext } from '@app/components/UI/UserGroupProvider/UserGroupProvider';

const DashboardLayout = loadable(() =>
	import(/* webpackChunkName: "DashboardLayout" */ '@app/components/Layouts/DashboardLayout/DashboardLayout'));

interface Props {
	component: any;
	redirectPath?: string;
	path: string;
	title?: string;
	dashboard?: boolean;
}

const DashboardRoute: React.FC<Props> = ({
	component: Component, redirectPath = '/', dashboard = true, title, ...rest
}) => {
	const { checkUserGroupAccess } = useUserGroupContext();
	const context = useSizableProviderContext();

	return (
		<SecureRouteWrapper path={rest.path as string} redirectPath={redirectPath}>
			{(checkUserGroupAccess(UserGroupType.DashboardMenuInWizard) || dashboard) && !context.state
				? (
					<DashboardLayout>
						{title || dashboard ? (
							<Helmet>
								<title>{title}</title>
							</Helmet>
						) : null}
						<Component />
					</DashboardLayout>
				) : <Component /> }
		</SecureRouteWrapper>
	);
};

export default DashboardRoute;
